import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import { Link, useNavigate, useParams } from "react-router-dom";
import apiClient from "../../components/utils/apiClient";
import Loading from "../../components/shared/Loading";
import { CITIES, FIELDS } from "../../components/utils/constants";
import GetRequestStyle from "../../components/helpers/GetRequestStyle";
import useUser from "../../components/helpers/useUser";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../../components/shared/NormalButton";
import InputField from "../../components/shared/InputField";
import Toast from "../../components/shared/Toast";
import { UserContext } from "../../App";
import MultiSelect from "../../components/shared/MultiSelect";
import WorkerModalContainer from "../../containers/shared/WorkerModalContainer";
import { useSearchParams } from 'react-router-dom';
import GetServiceByCode from "../../components/helpers/GetServiceByCode";
import Comments from "../../components/InternalComments/Comments";

const SingleRequestPage = () => {
    const {t,i18n} = useTranslation();
    const { id } = useParams();

    const [searchParams] = useSearchParams();
    const [business,] = useState(searchParams.get('business') || null);

    const [singleRequest, setSingleRequest] = useState(null);
    useDocumentTitle(singleRequest ? `${t('requests.requestNumber')}${singleRequest?.business ? singleRequest?.prettyId : singleRequest?.requestPrettyId}` : t('nav.requests'));
    const pageTitle = {title: singleRequest ? `${t('requests.requestNumber')}${singleRequest?.business ? singleRequest?.prettyId : singleRequest?.requestPrettyId}` : t('nav.requests'), subTitle: ''};

    const [user,setUser] = useUser();
    const [vendor, setVendor] = useState(null);
    const navigate = useNavigate();

    const [isActionLoading, setIsActionLoading] = useState(false);

    const [showPhoneNumber, setShowPhoneNumber] = useState(false);

    const [postponeModal, setPostponeModal] = useState(false);
    const [postponeReason, setPostponeReason] = useState('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [toast, setToast] = useState({show: false,type: null, message:'' });

    const {confguration, fields} = useContext(UserContext);
    const [postponeReasonsOptions, setPostponeReasonsOptions] = useState(null);

    const [addWorkerToRequset, setAddWorkerToRequset] = useState(false);
    const [selectedWorker, setSelectedWorker] = useState(null);
    const [workersOptions, setWorkersOptions] = useState(null);

    const [requestActions, setRequestActions] = useState([]);


    const getWorkers = async () => {

      try {
        const response = await apiClient.get(`/users?types=worker&vendorsId=${user?._id}`);
        if(response?.data) {
          setWorkersOptions(response?.data?.map(worker=>({label:worker?.name, value:worker?._id})));
        } else {

        }
      } catch(err) {}
    }

    const getUserData = async () => {
      try {
        const response = await apiClient.get(`/vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }


    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
            getWorkers();
        }
    },[user])

    const getSingleRequest = async () => {
        try {
          const businessParam = business ? `&business=${business}` : '';
          const response = await apiClient.get(`/requests/vendor-prettyId?requestPrettyId=${id}`+businessParam);
          if(response?.data) {
            setSingleRequest(response?.data);
            let actionsArray = [...response?.data?.statuses];
            if(response?.data?.activities) {
                actionsArray = [...actionsArray, ...response?.data?.activities?.filter(a=>a?.action === 'adminAssignWorker')];
            }
            const mergedActions = actionsArray.sort(
                (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
            );
            setRequestActions(mergedActions);

          } else {

          }
        } catch(err) {}
    }

    useEffect(()=>{
        if(id) {
            getSingleRequest();
        }
    },[id])


    useEffect(()=>{
        if(singleRequest && singleRequest?.worker?._id && workersOptions) {
            if(singleRequest?.worker?._id) setSelectedWorker(workersOptions?.find(w=>w?.value === singleRequest?.worker?._id)?.value);
        }
    },[singleRequest, workersOptions])

    const openWorkerLocation = (lat, lng) => {
        window.open(`https://maps.google.com/?q=${lat},${lng}`, '_blank');
    };

    useEffect(()=>{
        if(vendor && !vendor?.activeSubscription) {
            navigate(`/${i18n?.language || 'ar'}/settings/packages`);
        }
    },[vendor])


    const handleCloseModal = () => {
        setPostponeModal(false);
    }

    const handleCloseWorkerModal = () => {
        setAddWorkerToRequset(false);
    }


    const handleClickPostpone = () => {
        setPostponeReason('');
        setPostponeModal(true);
    }

    useEffect(()=>{
        if(postponeReason && postponeReason.length > 4) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    },[postponeReason])

    useEffect(()=>{
        if(confguration?.enums?.postponeReasons) {
            const postponeReasonsOptions = confguration?.enums?.postponeReasons?.map((reason) => ({
                value: reason?.code,
                label: reason?.messages?.[i18n.language === 'ar' ? 'ar' : 'en'] || reason?.messages?.ar
            }));
            setPostponeReasonsOptions(postponeReasonsOptions);
        }
    },[confguration])

    const handleClickPostponeAction = async () => {
        setIsButtonDisabled(true);
        try {
          const response = await apiClient.post(`/requests/postpone`,{"requestId": singleRequest?._id,"reason": postponeReason});
          if(response?.status === 200 || response?.status === 201 || response?.status === 204) {
            getSingleRequest();
            setToast({show:true,type:'success',message:t('requests.postponeSuccess')});
            setPostponeModal(false);
          } else {
            setToast({show:true,type:'error',message:t('requests.errorOccurredRetry')});
            setIsButtonDisabled(false);
          }
        } catch(err) {
            setToast({show:true,type:'error',message: err?.response?.data?.message || t('requests.errorOccurredRetry')});
            setIsButtonDisabled(false);
        }
    }

    useEffect(()=>{
        if(selectedWorker && selectedWorker !== singleRequest?.worker?._id) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    },[selectedWorker])

    const handleAddWorkerAction = async() => {
        const body = {
        "requestId": singleRequest?._id,
        "workerId": selectedWorker,
        "business": (singleRequest?.business?._id ? singleRequest?.business?._id : singleRequest?.business)  || ''
        }
        try {
            const response = await apiClient.post(`/requests/vendor-choose-worker`,body);
            if(response && response.status && (response.status === 201 || response.status === 200)) {
                setToast({show:true,type:'success',message:t('requests.workerAddedSuccess')});
                setAddWorkerToRequset(false);
                getSingleRequest();
            } else {
              setToast({show:true,type:'error',message:t('requests.errorOccurred')});

            }
        } catch (error) {
            setToast({show:true,type:'error',message: error?.response?.data?.message || t('requests.errorOccurredRetry')});
        }
    }


  return (
    <div>
      <PageHeader pageTitle={pageTitle} isColored />
      <PageMain>
        <div className="fixed top-0 left-0 w-full h-full bg-grey-50 !z-[-1]"></div>
        <MainContent>

            <div className="border-[1px] border-grey-200 rounded-[16px] px-[20px] py-[30px] my-[24px] bg-white">
                <div className="flex flex-nowrap lg:h-[146px]">
                    <div className="w-full lg:border-e-0 border-grey-200">
                        <div className="text-grey-900 text-[24px] font-[600] leading-[36px]">
                            {t('requests.maintenanceRequest')} #{singleRequest?.business ? singleRequest?.prettyId : singleRequest?.requestPrettyId}
                            {singleRequest?.business && <div className="inline-block align-middle bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] mx-[8px] text-[#FB00FF] text-[12px] font-[500]">{t('requests.faniAamal')}</div>}
                            {singleRequest?.status !== 'pending-favorite-worker-approval' && singleRequest?.requestedFavoriteWorker ? <div className="inline-block bg-grey-100 h-[22px] px-[8px] leading-[22px] rounded-[20px] mx-[8px] text-grey-600 text-[12px] font-[500]">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[4px]">
                                    <path d="M16.44 3.09961C14.63 3.09961 13.01 3.97961 12 5.32961C10.99 3.97961 9.37 3.09961 7.56 3.09961C4.49 3.09961 2 5.59961 2 8.68961C2 9.87961 2.19 10.9796 2.52 11.9996C4.1 16.9996 8.97 19.9896 11.38 20.8096C11.72 20.9296 12.28 20.9296 12.62 20.8096C15.03 19.9896 19.9 16.9996 21.48 11.9996C21.81 10.9796 22 9.87961 22 8.68961C22 5.59961 19.51 3.09961 16.44 3.09961Z" fill="#F04438"/>
                                </svg>
                                {t('requests.favoriteWorkerRequest')}
                            </div> : ''}
                            <div className="inline-block ms-[12px]">
                                {singleRequest?.status === 'pending-vendor-assignment'
                                && <div className="inline-block bg-[#0CB450]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#0CB450] text-[12px] font-[500] opacity-50">{t('requests.new')}</div>}

                                {singleRequest?.fanniHappy
                                && <div className="inline-block bg-orange/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-orange text-[12px] font-[500]">{t('requests.faniHappy')}</div>}
                            </div>
                        </div>
                        <div className="flex flex-wrap lg:flex-nowrap mt-[25px] pt-[20px] border-t-[1px] border-grey-200">
                            <div className="w-[50%] lg:w-[200px] h-[60px] relative">
                                <strong className="text-[24px] text-grey-900 font-[600] leading-[36px]">{fields?.find(f=>f?.field?.code === singleRequest?.field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === singleRequest?.field)?.field?.name?.ar}</strong>
                                <p className="text-[14px] text-grey-600 font-[500]">
                                <img src="/assets/images/worker-field.svg" alt="" className="inline-block align-sub me-[3px]" />
                                {t('requests.specialization')}
                                </p>
                                <span className="absolute block w-[1px] h-[40px] bg-grey-300 end-0 top-[10px]"></span>
                            </div>
                            <div className="w-[50%] lg:w-[260px] h-[60px] ps-[15px] lg:ps-[60px] relative">
                                <strong className="text-[24px] text-grey-900 font-[600] leading-[36px]">{singleRequest?.business ? CITIES[singleRequest?.addressDetails?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[singleRequest?.addressDetails?.city]?.ar : CITIES[singleRequest?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[singleRequest?.city]?.ar}</strong>
                                <p className="text-[14px] text-grey-600 font-[500]">
                                <img src="/assets/images/workers-cities-icon.svg" alt="" className="inline-block align-sub me-[3px]" />
                                {t('requests.city')}
                                </p>
                                <span className="absolute w-[1px] h-[40px] bg-grey-300 end-0 top-[10px] hidden lg:block"></span>
                            </div>
                            <div className="w-[50%] lg:w-[260px] lg:min-w-[260px] h-[60px] lg:ps-[60px] relative lg:pe-[40px]">
                                <strong className="text-[24px] text-grey-900 font-[600] leading-[36px]">{singleRequest?.business ? singleRequest?.addressDetails?.district?.[i18n.language === 'ar' ? 'ar' : 'en'] || singleRequest?.addressDetails?.district?.ar : singleRequest?.district?.[i18n.language === 'ar' ? 'ar' : 'en'] || singleRequest?.district?.ar || '-'}</strong>
                                <p className="text-[14px] text-grey-600 font-[500]">
                                <img src="/assets/images/requestinfo-location.svg" alt="" className="inline-block align-sub me-[3px]" />
                                {t('requests.district')}
                                </p>
                                <span className="absolute block w-[1px] h-[40px] bg-grey-300 end-0 top-[10px]"></span>
                            </div>
                            <div className="w-[50%] lg:w-[260px] h-[60px] ps-[15px] lg:ps-[60px] relative">
                                <strong className="text-[24px] text-grey-900 font-[600] leading-[36px]">{singleRequest?.business ? singleRequest?.assignedWorker?.name : singleRequest?.worker?.name || '-'}</strong>
                                <p className="text-[14px] text-grey-600 font-[500]">
                                <img src="/assets/images/requestinfo-tech.svg" alt="" className="inline-block align-sub me-[3px]" />
                                {t('requests.technician')}
                                <div className="inline-block ms-[3px] bg-black text-white leading-[20px] px-[8px] rounded-[6px] text-[13px] cursor-pointer select-none" onClick={()=>setAddWorkerToRequset(true)}>{singleRequest?.worker?._id ? t('requests.changeWorker') : t('requests.chooseWorker')}</div>
                                </p>
                                <span className="absolute w-[1px] h-[40px] bg-grey-300 end-0 top-[10px] hidden lg:block"></span>
                            </div>
                            <div className="w-[200px] h-[60px] lg:ps-[60px] relative whitespace-nowrap">
                                <strong className="text-[24px] text-grey-900 font-[600] leading-[36px]">{GetRequestStyle(singleRequest?.status)}{!['canceled','done','reviewed','timed-out'].includes(singleRequest?.status) && singleRequest?.isRescheduled ? <div className="inline-block bg-[#8d0cb4]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] ms-[8px] text-[#8d0cb4] text-[12px] font-[500]">{t('requests.scheduledRequest')}</div> : ''}</strong>
                                <p className="text-[14px] text-grey-600 font-[500]">
                                <img src="/assets/images/singleRequestinfo-status.svg" alt="" className="inline-block align-sub me-[3px]" />
                                {t('requests.status')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="flex flex-wrap lg:flex-nowrap gap-[32px] pb-[24px]">
                <div className="w-full lg:w-[50%]">
                    {!['canceled','done','reviewed','timed-out'].includes(singleRequest?.status) && singleRequest?.isRescheduled ? <>
                    <div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700]">{t('requests.schedulingDetails')}</div>
                    <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] overflow-hidden mb-[24px]">

                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[100%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]"> {t('requests.scheduledTo')} {singleRequest?.rescheduleInfo?.scheduledFor ? new Date(singleRequest?.rescheduleInfo?.scheduledFor).toLocaleDateString('en-GB', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,}) : t('requests.unspecified')} {t('requests.by')} {singleRequest?.rescheduleInfo?.rescheduledBy?.name ? singleRequest?.rescheduleInfo?.rescheduledBy?.name : t('requests.unknown')}</div>
                        </div>

                    </div>
                    </> :''}
                    <div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700]">{t('requests.customerData')}</div>
                    <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] overflow-hidden">

                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50px] lg:w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">{singleRequest?.business ? t('requests.unit') : t('requests.customer')}</div>
                            <div className="w-[calc(100%-50px)] lg:w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.unitName : singleRequest?.customer?.name || '-'}</div>
                        </div>

                        <div className="flex flex-nowrap bg-grey-50 px-[16px]">
                            <div className="w-[50px] lg:w-[50%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">{t('requests.address')}</div>
                            <div className="w-[calc(100%-50px)] lg:w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end truncate" title={singleRequest?.business ? singleRequest?.addressDetails?.addressLine : singleRequest?.addressLine}>{singleRequest?.business ? singleRequest?.addressDetails?.addressLine : singleRequest?.addressLine || '-'}</div>
                        </div>

                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[60px] lg:w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">{t('requests.directions')}</div>
                            <div className="w-[calc(100%-60px)] lg:w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{(singleRequest?.location || singleRequest?.addressDetails?.location) ? <><img src="/assets/images/request-location.svg" alt="" className="inline-block align-middle w-[24px] h-[24px] ms-[4px]" /> <span className="cursor-pointer font-[500] text-[14px] text-darkBlue inline-block align-middle" onClick={()=>singleRequest?.business ? openWorkerLocation(singleRequest?.addressDetails?.location?.latitude, singleRequest?.addressDetails?.location?.longitude) : openWorkerLocation(singleRequest?.location?.latitude, singleRequest?.location?.longitude)}>{t('requests.showDirections')}</span></> : t('requests.unspecified')}</div>
                        </div>

                        <div className="mt-[8px] px-[16px] text-grey-600">
                            <span className="text-danger">
                                *
                            </span>
                            {t('requests.contactCustomerNote')}
                        </div>

                        <div className="flex flex-wrap lg:flex-nowrap bg-grey-50 px-[16px] py-[12px] lg:h-[64px]">
                            <div className="w-full lg:w-[200px] my-[10px] lg:my-0">
                                    {singleRequest?.status === 'active' && <div className="text-[18px] font-[600] w-[156px] h-[40px] leading-[40px] text-center rounded-[8px] border-blue  border-[1px] text-blue cursor-pointer" onClick={()=>handleClickPostpone()}>{t('requests.postpone')}</div>}
                            </div>
                            <div className="w-full lg:w-[calc(100%-200px)] text-end">
                                <div className="text-[18px] font-[600] w-[156px] h-[40px] inline-block leading-[40px] text-center rounded-[8px] border-darkBlue border-[1px] text-darkBlue opacity-50 pointer-events-none select-none">{t('requests.chat')}</div>
                                { (singleRequest?.status === 'active' || singleRequest?.status === 'postponed') && singleRequest?.customer?.username && <div className="text-[18px] me-[12px] font-[600] w-[156px] h-[40px] inline-block leading-[40px] text-center rounded-[8px] border-darkBlue border-[1px] text-darkBlue cursor-pointer" dir="ltr" onClick={()=>{showPhoneNumber ? window.open(`tel:${singleRequest?.customer?.username}`, '_self') : setShowPhoneNumber(true)}}>{showPhoneNumber ? singleRequest?.business ? t('requests.unspecified') : '+'+singleRequest?.customer?.username : t('requests.call')}</div>}
                            </div>
                        </div>


                    </div>

                    {singleRequest?.worker ? <><div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700] mt-[24px]">{t('requests.workerData')}</div>
                    <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] overflow-hidden">


                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">{t('requests.worker')}</div>
                            <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.worker?.name ? <Link to={`/${i18n?.language || 'ar'}/workers/${singleRequest?.worker?.username}`} className="text-blue text-[14px] font-[400] me-[4px]">{singleRequest?.worker?.name}</Link> : '-'}</div>
                        </div>

                        <div className="flex flex-nowrap bg-grey-50 px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">{t('requests.mobileNumber')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end truncate ltr:text-start" dir="rtl" title={singleRequest?.worker?.username ? singleRequest?.worker?.username+'+' : t('requests.unspecified')}>{singleRequest?.worker?.username ? singleRequest?.worker?.username+'+' : t('requests.unspecified')}</div>
                        </div>

                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">{t('requests.specialization')}</div>
                            <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.worker?.fields?.map(wf=>fields?.find(f=>f?.field?.code === wf)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === wf)?.field?.name?.ar).join(', ')}</div>
                        </div>

                        <div className="flex flex-nowrap bg-grey-50 px-[16px]">
                            <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">{t('requests.workerLevel')}</div>
                            <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.worker?.classificationDetails?.title?.[i18n.language === 'ar' ? 'ar' : 'en'] || singleRequest?.worker?.classificationDetails?.title?.ar || '-'}</div>
                        </div>

                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">{t('requests.city')}</div>
                            <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{CITIES[singleRequest?.worker?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[singleRequest?.worker?.city]?.ar || '-'}</div>
                        </div>


                    </div></> : ''}

                    <div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700] mt-[24px]">{t('requests.requestStatusHistory')}</div>
                    <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] overflow-hidden">
                        { requestActions?.length > 0 ? requestActions?.map((singleStatus,sIndex) => {
                            return (
                            <div key={'single_status-'+singleStatus?.status+'-'+sIndex} className={`flex flex-wrap lg:flex-nowrap ${sIndex % 2 === 0 ? 'bg-white' : 'bg-grey-50'} px-[16px]`}>

                                <div className="w-full lg:w-[150px] lg:h-[37px] leading-[37px] text-blue text-[14px] font-[400] lg:truncate" title={GetRequestStyle(singleStatus?.status) || singleStatus?.actionDescription}>{GetRequestStyle(singleStatus?.status) || singleStatus?.actionDescription}</div>
                                <div className="w-full lg:w-[calc(100%-150px)] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end"><span dir="rtl">{`${t('requests.by')}: ${singleStatus?.createdBy ? singleStatus?.createdBy?.name : singleStatus?.user ? singleStatus?.user?.name : t('requests.unknown')}`}</span> {`[${new Date(singleStatus?.createdAt).toLocaleDateString('en-US', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true})}]`}</div>

                            </div>
                            )
                        }) : t('requests.noHistory')}
                    </div>


                    

                </div>
                <div className="w-full lg:w-[50%]">
                    <div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700]">{t('requests.requiredServices')}</div>
                    <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] overflow-hidden">

                        {singleRequest?.business ? 
                        (singleRequest?.initialWorkList?.length > 0 ? singleRequest?.initialWorkList?.map((item,index)=> {
                            return (<div key={'maintenanceList-'+index} className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[33.333%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]  truncate" title={GetServiceByCode(singleRequest?.field,item?.maintenanceCode)[1]}>{GetServiceByCode(singleRequest?.field,item?.maintenanceCode)[1]}</div>
                            <div className="w-[33.333%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-center">1</div>
                            <div className="w-[33.333%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{item?.cost || '0'} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div>)}) : <div className=" bg-white px-[16px] text-center leading-[37px] text-grey-900 text-[14px] font-[500]"> {t('requests.noServicesAvailable')} </div>)
                        : (singleRequest?.maintenanceListHistory?.length > 0 ? singleRequest?.maintenanceListHistory?.map((item,index)=> {
                            return (<div key={'maintenanceList-'+index} className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[33.333%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]  truncate" title={item?.maintenance?.name}>{item?.maintenance?.name}</div>
                            <div className="w-[33.333%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-center">1</div>
                            <div className="w-[33.333%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{item?.cost || '0'} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div>)})
                        : <div className=" bg-white px-[16px] text-center leading-[37px] text-grey-900 text-[14px] font-[500]"> {t('requests.noServicesAvailable')} </div>)}

                         <div className="flex flex-wrap lg:flex-nowrap bg-grey-50 px-[16px] py-[12px] lg:h-[64px]">
                            <div className="w-full flex flex-wrap lg:flex-nowrap">
                                <div className="w-full lg:w-[calc(100%-230px)] pe-[16px]">
                                    <span className="text-danger">
                                        *
                                    </span>
                                    {t('requests.confirmServicesNote')}
                                </div>
                                <div className="w-full lg:w-[228px] text-end">
                                    {['active','postpone'].includes(singleRequest?.status) &&<Link to={`/${i18n?.language || 'ar'}/complete-request/${singleRequest?.business ? singleRequest?.prettyId+'?business='+singleRequest?.business : singleRequest?.requestPrettyId}`} className="w-[228px] h-[40px] inline-block leading-[40px] text-center rounded-[8px] bg-darkBlue text-white text-[18px] font-[600] cursor-pointer mt-[10px] lg:mt-0"><img src="/assets/images/request-done.svg" alt="" className="inline-block me-[2px]" /> {t('requests.workDone')}</Link>}
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700] mt-[24px]">{t('requests.invoiceDetails')}</div>
                    <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] overflow-hidden">

                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.totalWorkerWage')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.workerWage : singleRequest?.workersWage} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div>

                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.totalPartsRequired')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.partsCost : singleRequest?.partsCost} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div>

                        {singleRequest?.deliveryCostOfParts ? <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.partsDeliveryFees')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.deliveryCostOfParts :singleRequest?.deliveryCostOfParts} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div> : ''}

                        {singleRequest?.serviceFee ? <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.serviceFees')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.serviceFee :singleRequest?.serviceFee} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div> : ''}

                        {/* <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.tax')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? Math.abs(singleRequest?.invoiceDetails?.vatValue) : Math.abs(singleRequest?.vatValue)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div> */}

                        {!singleRequest?.business ? <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.customerDiscount')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.workerWage : Math.abs(singleRequest?.discount)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div> : ''}

                        {!singleRequest?.business ? <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.workerTip')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.workerWage : Math.abs(singleRequest?.tipAmount)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div> : ''}

                        <div className="flex flex-nowrap bg-white px-[16px]">
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.total')}</div>
                            <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? Math.abs(singleRequest?.invoiceDetails?.total) : Math.abs(singleRequest?.totalAfterDiscount)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                        </div>


                    </div>

                    <Comments resourceLable={t('nav.requests')} resourceType={'requests'} resourceId={id} vendor={vendor} />
                </div>
            </div>

        </MainContent>
      </PageMain>

      {postponeModal && <ModalContainer heading={t('requests.postponeRequest')} handleCloseModal={handleCloseModal} noOverFlow>
        <div className="">

            <div className="">
                <div className="">
                    <MultiSelect isMulti={false} label={t('requests.choosePostponeReason')} placeholder={t('requests.searchPostponeReason')} options={postponeReasonsOptions} value={postponeReason} onChange={(option)=>{setPostponeReason(option.value)}} />
                </div>
            </div>
            <div className="w-full pt-[15px] text-end">
                <NormalButton label={t('requests.cancel')} color={'!bg-[transparent] !text-grey-400'} isDisabled={false} onClick={handleCloseModal} />
                <NormalButton label={t('requests.postpone')}  isDisabled={isButtonDisabled} onClick={()=>handleClickPostponeAction()} />
            </div>
        </div>
        </ModalContainer>}

        {addWorkerToRequset && <ModalContainer heading={t('requests.chooseWorkerModal')} handleCloseModal={handleCloseWorkerModal} noOverFlow>
            <div className="">

                <div className="">
                    <div className="mt-[20px] pt-[10px] border-t-[1px] border-grey-200">
                        <MultiSelect isMulti={false} label={t('requests.chooseWorkerModal')} placeholder={t('requests.searchWorker')} options={workersOptions} value={selectedWorker} onChange={(option)=>{setSelectedWorker(option.value )}} />
                    </div>
                </div>
                <div className="w-full pt-[15px] text-end">
                    <NormalButton label={t('requests.cancel')} color={'!bg-[transparent] !text-grey-400'} isDisabled={false} onClick={handleCloseWorkerModal} />
                    <NormalButton label={t('requests.selectWorker')}  isDisabled={isButtonDisabled} onClick={()=>handleAddWorkerAction()} />
                </div>

            </div>
        </ModalContainer>}



      {(!singleRequest || isActionLoading) && <Loading showLoading={true} />}
      <Toast toast={toast} setToast={setToast} />
    </div>
  );
};

export default SingleRequestPage;
